window.$mm_work_order_result = [];
window.$mm_work_order_treeChangeStatus = false;
window.$mm_work_order_page_number = 1;
window.$mm_work_order_Glist = [];
window.$mm_work_order_selectedRow = "";
window.$mm_work_order_content = [];
window.$mm_work_order_lastUsedTableFilter = [];
window.$mm_work_order_scroll_change = false;
window.$mm_work_order_filterClickStatus = false;
window.$mm_work_order_filterLastIds = [];
window.$mm_work_order_searchInputId = null;
window.$mm_work_order_columnList = [];
window.$mm_work_order_plannigAlgemeenGisratio = [];
window.$mm_work_order_plannigStatus = [];
window.$mm_work_order_maatregelNaam = [];
window.$mm_work_order_beheereenheidNaam = [];
window.$mm_work_order_beheeractiviteitLaag = [];
window.$mm_work_order_disciplineNaam = [];
window.$mm_work_order_statusTijdstipVerzonden = [];
window.$mm_work_order_filterCheckControlGPlannig = [false, false];
window.$mm_work_order_gvv = 1;
window.$mm_work_order_table_total_row_count = 0;
window.$mm_work_order_columnListPure = null;
window.$mm_work_order_refresh = function () {};
window.$mm_work_order_filterContent = [
  {
    key: "status-werkorder",
    and_or: "AND",
    values: [true],
    datatype: "BOOLEAN",
  },
];
window.$mm_work_order_filterCheckControl = [
  ["status-detailplanning", false, false],
  ["status-budget", false, false],
  ["status-globaleplanning", false, false],
  ["status-werkorder", false, false],
  ["status-verzonden", false, false],
  // ["status-werkplan", false, false],
];
window.$mm_work_order_filterClickControl = [
  ["status-detailplanning", false],
  ["status-budget", false],
  ["status-globaleplanning", false],
  ["status-werkorder", false],
  ["status-verzonden", false],
  ["status-werkplan", false],
];

window.$mm_work_order_actions = [];

window.$mm_work_order_column_order_post_model = {
  client_identification: "",
  code: "",
  data: {
    table_sorting: [
      {
        name: "management-maintenance>workorder",
        column_list: [
          "checkbox",
          "active",
          "Gisratio Id",
          "Status",
          "Naam maatregel",
          "Laag",
          "Naam beheereenheid",
          "Naam discipline",
          "Tijdstip verzonden",
          "Datum aangemaakt",
          "Datum laatst gewijzigd",
        ],
      },
    ],
  },
};
